import { Plugins } from '@leverege/plugin'
import Evaluator from './Evaluator.js'
import AsyncEvaluator from './AsyncEvaluator.js'
import { EvaluatorFactory, AsyncEvaluatorFactory, ConditionFactory } from './Factory.js'

function createFilterByObjectType( objectType ) {
  return ( condition ) => {
    if ( condition.objectType == null ) {
      return true
    }
    if ( typeof condition.objectType === 'string' ) {
      return condition.objectType === objectType
    }
    if ( Array.isArray( condition.objectType ) ) {
      return condition.objectType.includes( objectType )
    }
    if ( typeof condition.objectType === 'function' ) {
      return condition.objectType( objectType )
    }
    return false
  }
}

function getConditionsFor( objectType ) {
  return Plugins.createView( 'Condition', { name : objectType, filter : createFilterByObjectType( objectType ) } ).get()
}

function satisfies( condition, context, isAsync ) {
  return ( isAsync ? 
    AsyncEvaluator.satisfies( condition, context ) :
    Evaluator.satisfies( condition, context ) )
}

export default {
  getConditionsFor,
  createFilterByObjectType,
  satisfies,
  EvaluatorFactory, 
  AsyncEvaluatorFactory,
  ConditionFactory
}
